function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import { Auth } from 'aws-amplify';
import { toastr } from 'react-redux-toastr';
import Modal from '..';
import { saveAs } from 'file-saver';
import { Header } from '../Header';
import { Body } from './Body';
import { Footer } from '../Footer';
var toastrOptions = {
  timeOut: 3000,
  newestOnTop: true,
  position: 'top-right'
};

var ShoppingCartModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ShoppingCartModal, _React$Component);

  function ShoppingCartModal(props) {
    var _this;

    _classCallCheck(this, ShoppingCartModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ShoppingCartModal).call(this, props));

    _this.toggleItem = function (id) {
      _this.setState({
        error: false,
        resolution: _objectSpread({}, _this.state.resolution, _defineProperty({}, id, !_this.state.resolution[id]))
      });
    };

    _this.handleClick = function () {
      var shoppingCart = _this.props.shoppingCart;
      var userRole = _this.state.userRole;
      var id = _this.props.plotID;

      if (['premiumCustomer'].includes(userRole)) {
        var blob = new Blob(['Soy premium!'], {
          type: 'text/plain;charset=utf-8'
        });
        saveAs(blob, 'data.csv'); // for demo

        return _this.props.actions.hide('ShoppingCartModal');
      }

      var dataRates = [];
      var dataType = _this.state.resolution;
      var keys = Object.keys(dataType);
      keys.map(function (a) {
        if (dataType[a] === true) dataRates.push(a);
      });

      if (dataRates.length === 0) {
        return _this.setState({
          error: true
        });
      }

      _this.props.actions.hide('ShoppingCartModal');

      shoppingCart.add({
        id: id,
        dataRates: dataRates
      });
      var str = "".concat(dataRates);
      toastr.success("Added to cart: ".concat(id), str, toastrOptions);
    };

    var resolution = {};

    if (props.resolution) {
      // Fix mo this to redux store
      props.resolution.available.map(function (id) {
        resolution[id] = false;
        return id;
      });
    }

    _this.state = {
      resolution: resolution,
      error: false,
      loaded: false,
      isAuthenticated: false
    };
    return _this;
  }

  _createClass(ShoppingCartModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.authenticate();

      this.unlisten = function () {
        Auth.currentAuthenticatedUser().then(function (user) {
          // eslint-disable-next-line no-console
          console.log('M O D A L A U T H E N T I C A T E D ', user);
        }).catch(function () {
          if (_this2.state.isAuthenticated) _this2.setState({
            isAuthenticated: false
          });
        });
      };
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unlisten();
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      var _this3 = this;

      Auth.currentAuthenticatedUser().then(function (user) {
        var payload = user.signInUserSession.idToken.payload;
        var groups = payload['cognito:groups'];
        var userRole = groups ? groups[0] : payload['custom:initialRole'];
        var active = user.attributes['custom:active'];

        _this3.setState({
          loaded: true,
          isAuthenticated: true,
          userRole: userRole,
          active: active
        });
      }).catch(function (err) {
        // eslint-disable-next-line no-console
        console.log(err);

        _this3.setState({
          loaded: true,
          isAuthenticated: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var userRole = this.state.userRole;
      var label = ['premiumCustomer'].includes(userRole) ? 'Download' : 'Add to cart';
      if (!userRole) return null;
      return React.createElement(Modal, _extends({
        body: 'shopping_cart_modal-view',
        width: '30%'
      }, this.props, {
        closeable: true
      }), React.createElement(Header, {
        closeable: true,
        content: true,
        handleHide: this.props.handleHide
      }), React.createElement(Body, {
        label: label,
        error: this.state.error,
        checkbox: this.state,
        range: this.props.range,
        toggleItem: this.toggleItem,
        resolution: this.props.resolution
      }), React.createElement(Footer, {
        label: label,
        handleClick: this.handleClick
      }));
    }
  }]);

  return ShoppingCartModal;
}(React.Component);

ShoppingCartModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  user: PropTypes.string
};
export { ShoppingCartModal as default };